// Bilingual dictionary for Nunu Massage
export const translations = {
  en: {
    nav: {
      services: "Services",
      about: "The Studio",
      location: "Location",
      contact: "Book",
      bookNow: "Book Now",
    },
    hero: {
      overline: "Shanghai · Huangpu District",
      titleA: "A Sanctuary",
      titleB: "of Serenity.",
      subtitle:
        "Nunu Massage is a private wellness studio in the heart of Shanghai. Hand-picked therapists, unhurried rituals, and a quietude you can feel the moment you arrive.",
      cta: "Reserve on WhatsApp",
      ctaAlt: "Reach via WeChat",
      meta: "Open 24 hours · Daily",
    },
    marquee: [
      "Deep Tissue",
      "Aromatherapy",
      "Oil Ritual",
      "Swedish",
      "Hot Stone",
      "Foot Reflexology",
      "Couples Suite",
      "VIP Room",
    ],
    about: {
      overline: "The Studio",
      title: "An intimate retreat,\ntended by craft.",
      p1: "We believe a great massage is a conversation between hands and breath. Our therapists are trained in classical Chinese, Thai and Swedish techniques — the kind of training that takes years, not weekends.",
      p2: "Rooms are private. Linens are fresh daily. The tea is warm. Nothing here is rushed — because the quality of a session is measured in the stillness it leaves behind.",
      stats: [
        { k: "12+", v: "Years of practice" },
        { k: "5", v: "Private suites" },
        { k: "¥500", v: "Sessions from" },
      ],
    },
    services: {
      overline: "Sessions · 按摩项目",
      title: "Choose your pace.",
      subtitle:
        "Every session begins with a warm foot soak and a brief consultation. Pricing is all-inclusive — no hidden charges.",
      tiers: [
        {
          name: "Essential",
          zh: "经典",
          duration: "60 Minutes",
          price: "¥500",
          desc: "A considered full-body massage to unwind the week.",
        },
        {
          name: "Signature",
          zh: "招牌",
          duration: "90 Minutes",
          price: "¥700",
          desc: "Our most-booked ritual — deeper work, warm oils, fuller rest.",
        },
        {
          name: "Retreat",
          zh: "臻享",
          duration: "120 Minutes",
          price: "¥900",
          desc: "An unhurried two-hour escape, body and mind entirely reset.",
        },
      ],
      note: "Prices in RMB · 人民币 · Gratuity not expected.",
      book: "Book this session",
    },
    howItWorks: {
      overline: "How it works",
      title: "Three steps\nto stillness.",
      steps: [
        {
          n: "01",
          title: "Message us",
          p: "Send a WhatsApp or WeChat message with your preferred time and session length. We reply within minutes.",
        },
        {
          n: "02",
          title: "Confirm your slot",
          p: "We confirm availability, match you with a therapist and share simple arrival directions.",
        },
        {
          n: "03",
          title: "Arrive & unwind",
          p: "A warm foot soak, a cup of tea, and your session begins. Pay on-site — cash, WeChat Pay or Alipay.",
        },
      ],
    },
    therapist: {
      overline: "Our Therapists",
      title: "Hand-picked. Professionally trained.",
      p: "Each therapist is selected for skill, grace, and a genuine care for guests. You’ll be matched to a practitioner based on your request — deep pressure, lymphatic flow, stress release or pure relaxation.",
    },
    location: {
      overline: "Find Us",
      title: "Room 301, No. 122, Lane 253\nXingchang Road, Huangpu.",
      sub: "A short walk from Xinzha Road Station (Line 1), close to People's Square. Discreet residential entrance — please WhatsApp on arrival and we will guide you up.",
      viewMap: "Open in Maps",
      callUs: "Call the studio",
      mapNote: "Map not loading? Open in Maps or WhatsApp us for directions.",
    },
    faq: {
      overline: "Questions",
      title: "Good to know.",
      items: [
        {
          q: "How do I book?",
          a: "Message us on WhatsApp or WeChat with your preferred date, time and session length (60 / 90 / 120 minutes). We confirm within minutes. Walk-ins are welcome when a suite is free, but booking ahead is recommended.",
        },
        {
          q: "What are your prices?",
          a: "¥500 for 60 minutes, ¥700 for 90 minutes and ¥900 for 120 minutes. All-inclusive — no hidden fees, gratuity not expected. First-time guests who mention this website receive ¥100 off.",
        },
        {
          q: "How do I pay?",
          a: "Pay on-site after your session. We accept cash (RMB), WeChat Pay and Alipay. International cards are not accepted at the moment.",
        },
        {
          q: "What should I bring or wear?",
          a: "Nothing — fresh towels, disposable underwear, slippers and warm tea are provided. Arrive comfortable; a shower is available before and after your session.",
        },
        {
          q: "Can I choose my therapist or pressure?",
          a: "Yes. Tell us your preference when booking — deep pressure, gentle relaxation, or focus on specific areas — and we will match you accordingly.",
        },
        {
          q: "What is your cancellation policy?",
          a: "Plans change. Just message us at least 2 hours before your appointment to reschedule or cancel — no charge.",
        },
      ],
    },
    contact: {
      overline: "Booking",
      title: "Reserve your session.",
      p: "We reply within minutes during opening hours. For same-day appointments, WhatsApp is fastest.",
      whatsapp: "Message on WhatsApp",
      wechat: "Add us on WeChat",
      phoneLabel: "Direct line",
      addressLabel: "The studio",
      hoursLabel: "Hours",
      hours: "Open 24 hours · Daily",
      qrTitle: "Scan to connect",
      qrSub: "Open the camera on WhatsApp or WeChat and scan the code below.",
      qrWhatsapp: "WhatsApp · Emily",
      qrWechat: "WeChat · 艾米",
    },
    footer: {
      tag: "Nunu Massage · 上海 · Huangpu",
      rights: "All rights reserved.",
      privacy: "Privacy",
      terms: "Terms",
    },
    stickyBar: {
      label: "From ¥500 · Open 24h",
      cta: "Book on WhatsApp",
    },
    account: {
      signIn: "Sign in",
      myAccount: "My account",
      overline: "Member",
      hello: "Welcome",
      giftLabel: "Your first-visit gift",
      giftSub: "Show this code on WhatsApp or at the studio and receive ¥100 off your first session.",
      codeLabel: "Member code",
      prefLabel: "Preference",
      prefTitle: "Your usual session",
      prefSub: "Pick a favourite — we'll pre-fill your booking message with it.",
      bookCta: "Book on WhatsApp",
      bookHint: "Your name, session and member code are pre-filled.",
      anyTier: "a massage",
      waMessage: "Hi Nunu Massage, I'm {name}. I'd like to book {tier}. Member code: {code}",
      signOut: "Sign out",
      backHome: "Back to site",
    },
    wechatModal: {
      title: "Add Nunu Massage on WeChat",
      sub: "Open WeChat → Contacts → Add Friends → search by phone:",
      copy: "Copy number",
      copied: "Copied to clipboard",
      close: "Close",
    },
    promo: {
      tag: "First-visit gift",
      text: "Mention this site on WhatsApp & receive ¥100 off your first session.",
      cta: "Claim on WhatsApp",
    },
    testimonials: {
      overline: "Guests say",
      title: "Quietly recommended.",
      subtitle:
        "Hand-picked excerpts from our guests on Dianping, Xiaohongshu and Google.",
      items: [
        {
          q: "Found this place by accident on Xiaohongshu — now my Sunday ritual. Therapist read my shoulders better than any spa I've tried in Shanghai.",
          name: "Olivia W.",
          role: "Expat · Huangpu",
          src: "Google Reviews",
        },
        {
          q: "Discreet, immaculately clean, the tea is excellent. The 90-minute Signature is worth every yuan. Already booked again.",
          name: "陈先生",
          role: "Repeat guest",
          src: "Dianping · 大众点评",
        },
        {
          q: "I came in tense and walked out floating. Real craft, no rushing, no upselling. The gold standard for Shanghai.",
          name: "Sofia K.",
          role: "Travel writer",
          src: "Xiaohongshu",
        },
        {
          q: "上海最让我安心的一家。环境、手法、服务都很到位，技师非常专业。",
          name: "林女士",
          role: "本地客人",
          src: "大众点评",
        },
      ],
      meta: "★ 4.9 average · 200+ five-star reviews across platforms",
    },
  },
  zh: {
    nav: {
      services: "项目",
      about: "关于",
      location: "位置",
      contact: "预约",
      bookNow: "立即预约",
    },
    hero: {
      overline: "上海 · 黄浦区",
      titleA: "都市之中",
      titleB: "宁静一隅。",
      subtitle:
        "Nunu Massage 位于上海黄浦区，是一间低调而专业的私人按摩会所。精选技师、完整的仪式感，还有你一进门就能感受到的宁静。",
      cta: "WhatsApp 预约",
      ctaAlt: "微信联系",
      meta: "全天 24 小时营业",
    },
    marquee: [
      "深层按摩",
      "芳香疗法",
      "精油仪式",
      "瑞典式",
      "热石按摩",
      "足底反射",
      "情侣套房",
      "VIP 贵宾房",
    ],
    about: {
      overline: "关于会所",
      title: "一间小而精致的私人休憩之所。",
      p1: "我们相信，一场好的按摩，是手与呼吸之间的对话。技师们经过中式、泰式、瑞典式等多年系统训练，而非短期速成。",
      p2: "房间完全独立，布草每日更换，奉一杯温茶。这里的一切都不急促——因为衡量一次好按摩的，是它留下的那份安宁。",
      stats: [
        { k: "12+", v: "年从业经验" },
        { k: "5", v: "独立私人房间" },
        { k: "¥500", v: "起步价" },
      ],
    },
    services: {
      overline: "按摩项目 · Sessions",
      title: "选择属于你的节奏。",
      subtitle: "每次体验都从暖足浴与简短咨询开始。价格透明，无隐藏消费。",
      tiers: [
        {
          name: "经典",
          zh: "Essential",
          duration: "60 分钟",
          price: "¥500",
          desc: "一次恰到好处的全身按摩，放下一整周的疲惫。",
        },
        {
          name: "招牌",
          zh: "Signature",
          duration: "90 分钟",
          price: "¥700",
          desc: "最受欢迎的项目——更深入的手法、温热的精油、更充分的休息。",
        },
        {
          name: "臻享",
          zh: "Retreat",
          duration: "120 分钟",
          price: "¥900",
          desc: "两小时的完全放空，身与心彻底重启。",
        },
      ],
      note: "价格均为人民币 · 无需另付小费。",
      book: "预约此项目",
    },
    howItWorks: {
      overline: "预约流程",
      title: "三步，\n抵达宁静。",
      steps: [
        {
          n: "01",
          title: "发送消息",
          p: "通过 WhatsApp 或微信告诉我们你希望的时间与项目时长，几分钟内回复。",
        },
        {
          n: "02",
          title: "确认时段",
          p: "我们确认档期、为你匹配技师，并发送简单的到店指引。",
        },
        {
          n: "03",
          title: "到店放松",
          p: "暖足浴、一杯温茶，随后开始你的专属时光。到店支付——现金、微信或支付宝。",
        },
      ],
    },
    therapist: {
      overline: "关于技师",
      title: "精心挑选 · 专业训练。",
      p: "每一位技师都经过严格挑选，不仅在手法上纯熟，更懂得照顾客人的感受。我们会根据你的需求——深层松筋、淋巴疏通、舒压或纯粹放松——为你匹配合适的技师。",
    },
    location: {
      overline: "位置",
      title: "上海黄浦区新昌路\n253 弄 122 号 301 室。",
      sub: "近地铁新闸路站 (1号线)，步行可达人民广场。住宅楼入口较为低调，到达时请 WhatsApp 通知我们，我们会引导你上楼。",
      viewMap: "在地图中打开",
      callUs: "致电会所",
      mapNote: "地图无法加载？请点击「在地图中打开」或通过 WhatsApp 联系我们获取路线。",
    },
    faq: {
      overline: "常见问题",
      title: "你可能想知道。",
      items: [
        {
          q: "如何预约？",
          a: "通过 WhatsApp 或微信告诉我们你希望的日期、时间与项目时长（60 / 90 / 120 分钟），几分钟内确认。有空房时也接受直接到店，但建议提前预约。",
        },
        {
          q: "价格是多少？",
          a: "60 分钟 ¥500，90 分钟 ¥700，120 分钟 ¥900。价格全包，无隐藏消费，无需小费。首次到店提及本网站即享 ¥100 优惠。",
        },
        {
          q: "如何支付？",
          a: "服务结束后到店支付，支持现金、微信支付与支付宝。暂不支持国际信用卡。",
        },
        {
          q: "需要携带什么？",
          a: "无需携带任何物品——提供干净毛巾、一次性内衣、拖鞋与温茶。可在按摩前后淋浴。",
        },
        {
          q: "可以指定技师或力度吗？",
          a: "可以。预约时告诉我们你的偏好——深层力度、轻柔放松或重点部位——我们会为你匹配合适的技师。",
        },
        {
          q: "取消政策是什么？",
          a: "计划有变？只需在预约时间前 2 小时通知我们改期或取消，不收取任何费用。",
        },
      ],
    },
    contact: {
      overline: "预约",
      title: "预订你的专属时段。",
      p: "营业时间内几分钟内回复。如需当日到店，建议使用 WhatsApp 最为便捷。",
      whatsapp: "通过 WhatsApp 预约",
      wechat: "添加微信",
      phoneLabel: "联系电话",
      addressLabel: "会所地址",
      hoursLabel: "营业时间",
      hours: "全天 24 小时营业",
      qrTitle: "扫码添加",
      qrSub: "使用 WhatsApp 或微信扫一扫，直接添加预约。",
      qrWhatsapp: "WhatsApp · Emily",
      qrWechat: "微信 · 艾米",
    },
    footer: {
      tag: "Nunu Massage · 上海 · 黄浦",
      rights: "保留所有权利。",
      privacy: "隐私",
      terms: "条款",
    },
    stickyBar: {
      label: "¥500 起 · 24 小时营业",
      cta: "WhatsApp 预约",
    },
    account: {
      signIn: "登录",
      myAccount: "我的账户",
      overline: "会员",
      hello: "欢迎",
      giftLabel: "首次体验礼遇",
      giftSub: "在 WhatsApp 或到店时出示此码，首次体验立减 ¥100。",
      codeLabel: "会员码",
      prefLabel: "偏好",
      prefTitle: "你的常选项目",
      prefSub: "选择一个常选项目，我们会自动填入你的预约信息。",
      bookCta: "WhatsApp 预约",
      bookHint: "已自动填入你的姓名、项目与会员码。",
      anyTier: "按摩项目",
      waMessage: "你好 Nunu Massage，我是 {name}，想预约 {tier}。会员码：{code}",
      signOut: "退出登录",
      backHome: "返回网站",
    },
    wechatModal: {
      title: "添加 Nunu Massage 微信",
      sub: "打开微信 → 通讯录 → 添加朋友 → 手机号搜索：",
      copy: "复制号码",
      copied: "已复制到剪贴板",
      close: "关闭",
    },
    promo: {
      tag: "首次体验礼遇",
      text: "首次到店在 WhatsApp 提及本网站即享 ¥100 优惠。",
      cta: "通过 WhatsApp 领取",
    },
    testimonials: {
      overline: "客人评价",
      title: "口碑相传，悄悄推荐。",
      subtitle: "节选自大众点评、小红书与 Google 上的真实留言。",
      items: [
        {
          q: "在小红书无意间刷到，从此每周日都来。技师真的会读你的肩膀，是上海试过最专业的一家。",
          name: "Olivia W.",
          role: "外籍客人 · 黄浦",
          src: "Google Reviews",
        },
        {
          q: "环境低调干净，茶水也讲究。90 分钟招牌项目非常值，已预约下一次。",
          name: "陈先生",
          role: "回头客",
          src: "大众点评",
        },
        {
          q: "进门紧绷，出门像在飘。手法纯熟，不催不推销，真正的上海高端水准。",
          name: "Sofia K.",
          role: "旅行作家",
          src: "小红书",
        },
        {
          q: "上海最让我安心的一家。环境、手法、服务都很到位，技师非常专业。",
          name: "林女士",
          role: "本地客人",
          src: "大众点评",
        },
      ],
      meta: "★ 平均 4.9 · 全平台 200+ 五星好评",
    },
  },
};

export const CONTACT = {
  brand: "Nunu Massage",
  phone: "+8618473441056",
  phoneDisplay: "+86 184 7344 1056",
  whatsappUrl: "https://wa.me/8618473441056",
  wechatProtocol: "weixin://dl/chat?+8618473441056",
  address: "Room 301, No. 122, Lane 253, Xingchang Road, Huangpu District, Shanghai, China",
  addressZh: "上海市黄浦区新昌路 253 弄 122 号 301 室",
  mapUrl:
    "https://www.google.com/maps/search/?api=1&query=%E4%B8%8A%E6%B5%B7%E5%B8%82%E9%BB%84%E6%B5%A6%E5%8C%BA%E6%96%B0%E6%98%8C%E8%B7%AF253%E5%BC%84122%E5%8F%B7",
  mapEmbedUrl:
    "https://www.google.com/maps?q=%E4%B8%8A%E6%B5%B7%E5%B8%82%E9%BB%84%E6%B5%A6%E5%8C%BA%E6%96%B0%E6%98%8C%E8%B7%AF253%E5%BC%84&z=17&output=embed",
};

export const IMAGES = {
  hero: "https://customer-assets.emergentagent.com/job_therapist-booking-cn/artifacts/fiun1lgk_18.jpeg",
  portrait:
    "https://customer-assets.emergentagent.com/job_therapist-booking-cn/artifacts/ro7oa9cn_21.jpeg",
  therapist:
    "https://customer-assets.emergentagent.com/job_therapist-booking-cn/artifacts/hb1qjviy_23.jpeg",
  cultural:
    "https://customer-assets.emergentagent.com/job_therapist-booking-cn/artifacts/5yimuhq0_24.jpeg",
  interior:
    "https://images.pexels.com/photos/35546242/pexels-photo-35546242.jpeg",
  zen: "https://static.prod-images.emergentagent.com/jobs/3d9f44cc-72be-4c81-98df-9fa95ab4ba52/images/35ac9d5c48d466f565b38004cfd003246e6e82bfc21e327d5f6db1d93812a2f9.png",
  wechatQR:
    "https://customer-assets.emergentagent.com/job_therapist-booking-cn/artifacts/90eadjws_28.jpeg",
  whatsappQR:
    "https://customer-assets.emergentagent.com/job_therapist-booking-cn/artifacts/9vqv8031_30.jpeg",
};
